export function isMobileScreen() {
    return window.matchMedia("(max-width: 767px)").matches;
}
